import React, { useState } from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'
import moment from 'moment'

import DateInput from '@components/inputs/textInput/dateInput'
import SecondaryButton from '@components/inputs/button/secondaryButton'
import PrimaryButton from '@components/inputs/button/primaryButton'
import ConfirmationModal from '@components/modal/confirmationModal'

import {
  isNormalFormatValidDate,
  getDateStringFromFormattedDateStr
} from '@util/timeUtil'

import {
  CloseIcon,
  Area,
  RowGap,
  Container,
  Section,
  ErrorText,
} from './styles'
import { AreaLabel, Title } from '../styles'

const SearchExamsModal = ({ isOpen, setClose, onSearch }) => {
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const datesValid = () => {
    if (!startDate || !endDate) return false
    if (!isNormalFormatValidDate(startDate) || !isNormalFormatValidDate(endDate)) return false
    return true
  }

  const dateRangeError = () => {
    if (!datesValid()) return null
    const start = moment(startDate, 'DD/MM/YYYY')
    const end = moment(endDate, 'DD/MM/YYYY')
    if (end.isSameOrBefore(start)) return 'A data final deve ser posterior à data inicial.'
    if (moment().startOf('day').diff(start.clone().startOf('day'), 'days') > 60) return 'A data inicial não pode ser anterior a 60 dias atrás.'
    if (end.clone().startOf('day').diff(start.clone().startOf('day'), 'days') > 7) return 'O intervalo entre as datas não pode ser maior que 7 dias.'
    return null
  }

  const handleSearch = () => {
    const formattedStart = getDateStringFromFormattedDateStr(startDate)
    const formattedEnd = getDateStringFromFormattedDateStr(endDate)
    onSearch(formattedStart, formattedEnd)
    setClose()
  }

  const error = dateRangeError()

  return (
    <ConfirmationModal isOpen={isOpen}>
      <Container>
        <CloseIcon className="material-icons-outlined" onClick={setClose}>close</CloseIcon>
        <Title>Buscar novos exames</Title>
        <Section>
          <RowGap>
            <Area>
              <AreaLabel>Data inicial</AreaLabel>
              <DateInput
                value={startDate}
                onChange={setStartDate}
              />
            </Area>
            <Area>
              <AreaLabel>Data final</AreaLabel>
              <DateInput
                value={endDate}
                onChange={setEndDate}
              />
            </Area>
          </RowGap>
          {error && <ErrorText>{error}</ErrorText>}
        </Section>
        <RowGap>
          <SecondaryButton onClick={setClose}>Cancelar</SecondaryButton>
          <PrimaryButton onClick={handleSearch} disabled={!datesValid() || !!error}>
            Buscar
          </PrimaryButton>
        </RowGap>
      </Container>
    </ConfirmationModal>
  )
}

SearchExamsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setClose: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default SearchExamsModal
